import React from 'react';
import ReactDOM from 'react-dom/client';
import './app/i18n';
import './styles/colors_and_type.css';
import './styles/site.css';
import './styles/order-flow.css';
import './styles/waiter-root.css';
import './styles/tailwind.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './app/store';
import App from './App';
import { initSentry } from './observability/sentry';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
